import React from 'react'

const techStackData = [
  {
    id: 1,
    title: 'Smart Contracts',
    technologies: ['Solidity', 'Rust', 'Web3.js', 'Ethers.js', 'Hardhat', 'Truffle', 'OpenZeppelin']
  },
  {
    id: 2,
    title: 'Web & mobile custom software development',
    technologies: ['React', 'Angular', 'Vue.js', 'Node.js', 'Python', 'Java', 'Swift', 'Kotlin', 'React Native', 'Flutter']
  },
  {
    id: 3,
    title: 'Cloud integration & serverless architecture',
    technologies: ['AWS Lambda', 'Azure Functions', 'Google Cloud', 'Serverless Framework', 'Docker', 'Kubernetes']
  },
  {
    id: 4,
    title: 'MVP, PoC, and project discovery',
    technologies: ['Agile', 'Scrum', 'Lean Startup', 'Design Thinking', 'Prototyping', 'Market Research']
  },
  {
    id: 5,
    title: 'AI integration',
    technologies: ['TensorFlow', 'PyTorch', 'OpenAI API', 'LangChain', 'Machine Learning', 'NLP', 'Computer Vision']
  },
  {
    id: 6,
    title: 'UI/UX design',
    technologies: ['Figma', 'Adobe XD', 'Sketch', 'InVision', 'Prototyping', 'User Research', 'Wireframing']
  }
]

const Technology = () => {
  return (
    <section id='technology'>
      <div className="container brd-white top-none p-5">
        <h2 className="title-intro c-white">TechStack</h2>
        <div className="s-50"></div>
        <div className="row">
          {techStackData.map((stack) => (
            <div key={stack.id} className="col-lg-4 mb-4">
              <div className="brd-white px-5 py-5" style={{ height: '100%', minHeight: '350px', display: 'flex', flexDirection: 'column' }}>
                <h3 className="title c-white mb-4">{stack.title}</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {stack.technologies.map((tech, index) => (
                    <span 
                      key={index} 
                      className="c-white meta"
                      style={{
                        padding: '6px 12px',
                        border: '1px solid #ffffff',
                        borderRadius: '20px',
                        fontSize: '14px',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export {Technology}
